import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 70.9 70.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 70.9 70.9\" id=\"icon-success\">\r\n<style type=\"text/css\">\r\n</style>\r\n<path class=\"st0\" d=\"M35.5,7.9C20.3,7.9,7.9,20.3,7.9,35.4S20.3,63,35.5,63S63,50.6,63,35.4S50.6,7.9,35.5,7.9z M47.2,30.6\r\n\tL34.1,43.7c-0.9,0.9-2.4,0.9-3.3,0l-7.1-7.1c-0.9-0.9-0.9-2.4,0-3.3c0.9-0.9,2.4-0.9,3.3,0l5.5,5.5l11.4-11.4c0.9-0.9,2.4-0.9,3.3,0\r\n\tC48.1,28.2,48.1,29.6,47.2,30.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol